import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBudgets = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2 10a8 8 0 0 1 8-8v8h8a8 8 0 1 1-16 0Z",
		fill: "var(--main-color)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 2.252A8.014 8.014 0 0 1 17.748 8H12V2.252Z",
		fill: "var(--main-color)"
	})]
});
export { SvgBudgets as ReactComponent };
